import * as Vue from "vue";
import {Component} from "vue-property-decorator";
import "./installersView.styl";
const template = require("./installersView.vue");

@Component({
  template: template
})
export class InstallersViewComponent extends Vue {

}

Vue.component("cmInstallersView", InstallersViewComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/views/installersView/installersView.ts